import { render } from "./ConfigurationForm.vue?vue&type=template&id=092050d5&scoped=true"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js"

import "./ConfigurationForm.vue?vue&type=style&index=0&id=092050d5&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092050d5"]])

export default __exports__